import {combineReducers} from "redux";
import { call, put, select, takeLatest, delay } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { reportParamsReducer } from "./reportParams/reportParamsReducer";
import { getFormParams, getHEOFormattedData } from "../../../utils/summGraduatesReports";
import { summGraduatesHEODetailsReducer } from "./details/privilegesDetailsReducer";



export const SUMM_GRADUATES_HEO_REQUEST = "SUMM_GRADUATES_HEO_REQUEST";
export const GRADUATES_DETAILS_REQUEST = "GRADUATES_DETAILS_REQUEST";
export const SET_FORM_DATA = "SET_SUMM_GRADUATES_HEO_FORM_DATA";
export const SET_REPORT_PARAMS = "SET_SUMM_GRADUATES_HEO_YEAR";
export const SET_DETAILS_FORM_DATA = "SET_DETAILS_FORM_DATA";

export const summGraduatesHEOReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    report_params: reportParamsReducer,
    details: summGraduatesHEODetailsReducer,
});

//actions
export const actions = createActions('report', SUMM_GRADUATES_HEO_REQUEST);
export const summGraduatesDetailsActions = createActions('summGraduatesDetails', GRADUATES_DETAILS_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});
export const setReportParams = payload => ({ type: SET_REPORT_PARAMS, payload});
export const setDetailsFormData = payload => ({ type: SET_DETAILS_FORM_DATA, payload});

// SAGAS
export function* summGraduatesHEOWatcher() {
    yield takeLatest(`${SUMM_GRADUATES_HEO_REQUEST}${START}`, summGraduatesHEOWorker)
    yield takeLatest(`${GRADUATES_DETAILS_REQUEST}${START}`, detailsWorker)
}

function* summGraduatesHEOWorker () {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.summGraduatesHEO.form)
        const payload = getFormParams(form)
        const params = {...auth, ...payload}
        const response = yield call(reportsAPI.summGraduatesHEO, params);
        const data = getHEOFormattedData(response.data.Answer.Data)
        yield put(actions.reportRequestSuccess(data));
        yield put(setReportParams(form))
    } catch(error) {
        yield put(actions.reportRequestError(error));
    }
}

function* detailsWorker({ payload }) {
    try {
        const {both, ...restParams} = payload
        const auth = yield select(state => state.auth.data)
        const {groupmode, ...form} = yield select(state => state.reports.summGraduatesHEO.form)
        const params = {...auth, ...form, ...restParams}
        const response = yield call(reportsAPI.summGraduatesDetails, params);
        yield put(summGraduatesDetailsActions.summGraduatesDetailsRequestSuccess(response.data.Answer.Data));
        yield put(setDetailsFormData(payload));
        if (response.data.Answer.Result == 'Error') {
            yield put(summGraduatesDetailsActions.summGraduatesDetailsRequestSuccess([]));
            yield put(setDetailsFormData([]));
        }
    } catch(error) {
        yield put(summGraduatesDetailsActions.summGraduatesDetailsRequestError(error));
        yield put(setDetailsFormData(payload));
    }
}